import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreboToolRoutingModule } from './crebo-tool-routing.module';
import { UploadComponent } from './upload/upload.component';
import { DownloadComponent } from './download/download.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule, MatButtonModule } from '@angular/material';
import { HttpClientModule } from '@angular/common/http';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';
import { FileUploadModule } from 'app/file-upload/file-upload.module';

@NgModule({
    imports: [
        CommonModule,
        CreboToolRoutingModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        HttpClientModule,
        FileUploadModule
    ],
    declarations: [UploadComponent, DownloadComponent],
    providers: [
        SemsoSnackbarService
    ]
})
export class CreboToolModule { }



// WEBPACK FOOTER //
// ./src/app/crebo-tool/crebo-tool.module.ts